////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const notifications = {
	getLogsNotification: () => ({
		type: ActionsTypes.GET_LOGS_NOTIFICATION,
	}),
	getLogsNotificationSuccess: (data) => ({
		type: ActionsTypes.GET_LOGS_NOTIFICATION_SUCCESS,
		payload: {
			data,
		},
	}),
	getLogsNotificationFailure: (error) => ({
		type: ActionsTypes.GET_LOGS_NOTIFICATION_FAILURE,
		payload: {
			error,
		},
	}),

	updateResolvedLog: (id) => ({
		type: ActionsTypes.UPDATE_RESOLVED_LOG,
		payload: {
			id,
		},
	}),
	updateResolvedLogSuccess: (data) => ({
		type: ActionsTypes.UPDATE_RESOLVED_LOG_SUCCESS,
		payload: {
			data,
		},
	}),
	updateResolvedLogFailure: (error) => ({
		type: ActionsTypes.UPDATE_RESOLVED_LOG_FAILURE,
		payload: {
			error,
		},
	}),

	updateRemotedLog: (id) => ({
		type: ActionsTypes.UPDATE_REMOTED_LOG,
		payload: {
			id,
		},
	}),
	updateRemotedLogSuccess: (data) => ({
		type: ActionsTypes.UPDATE_REMOTED_LOG_SUCCESS,
		payload: {
			data,
		},
	}),
	updateRemotedLogFailure: (error) => ({
		type: ActionsTypes.UPDATE_REMOTED_LOG_FAILURE,
		payload: {
			error,
		},
	}),

	closeNotification: (id) => ({
		type: ActionsTypes.CLOSE_NOTIFICATION,
		payload: {
			id,
		},
	}),
	closeNotificationSuccess: (data) => ({
		type: ActionsTypes.CLOSE_NOTIFICATION_SUCCESS,
		payload: {
			data,
		},
	}),
	closeNotificationFailure: (error) => ({
		type: ActionsTypes.CLOSE_NOTIFICATION_FAILURE,
		payload: {
			error,
		},
	}),

	closeAllNotification: (ids = []) => ({
		type: ActionsTypes.CLOSE_ALL_NOTIFICATION,
		payload: {
			ids,
		},
	}),
	closeAllNotificationSuccess: (data) => ({
		type: ActionsTypes.CLOSE_ALL_NOTIFICATION_SUCCESS,
		payload: {
			data,
		},
	}),
	closeAllNotificationFailure: (error) => ({
		type: ActionsTypes.CLOSE_ALL_NOTIFICATION_FAILURE,
		payload: {
			error,
		},
	}),

	reportNotification: (id) => ({
		type: ActionsTypes.REPORT_NOTIFICATION,
		payload: {
			id,
		},
	}),
	reportNotificationSuccess: (data) => ({
		type: ActionsTypes.REPORT_NOTIFICATION_SUCCESS,
		payload: {
			data,
		},
	}),
	reportNotificationFailure: (error) => ({
		type: ActionsTypes.REPORT_NOTIFICATION_FAILURE,
		payload: {
			error,
		},
	}),
	closeNotificationsPolling: () => ({
		type: ActionsTypes.CLOSE_NOTIFICATIONS_POLLING,
		payload: {},
	}),
}

export default notifications
